import { makeStyles } from '@material-ui/core/styles';
import { Theme } from 'enum';

export const useStyle = makeStyles((theme) => {
    const isLightMode = theme.palette.type === Theme.Light;
    return {
        root: {
            padding: '25px 0',
            position: 'relative',
            backgroundColor: isLightMode ? 'rgb(250,250,250)' : 'rgb(38,38,38)',
        },
        leftSide: {
            padding: theme.spacing(4, 0),
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            [theme.breakpoints.down('sm')]: {
                padding: 0,
                paddingRight: theme.spacing(4),
            },
        },
        logo: {
            padding: 0,
            overflow: 'hidden',
            width: 140,
            height: 140,
            flex: '0 0 140px',
            marginRight: theme.spacing(3),
            backgroundColor: '#fff',
            display: 'flex',
            '& a': {
                display: 'flex',
                width: '100%',
            },
            '& img': {
                cursor: 'pointer',
                width: '100%',
                height: '100%',
                objectFit: 'contain',
            },
            [theme.breakpoints.down('sm')]: {
                width: 90,
                height: 90,
                flex: '0 0 90px',
            },
            [theme.breakpoints.down(400)]: {
                width: 60,
                height: 60,
                flex: '0 0 60px',
                marginRight: theme.spacing(2),
            },
        },
        defaultLogo: {
            backgroundColor: isLightMode ? theme.palette.background.paper : theme.palette.background.default,
            '& img': {
                filter: isLightMode ? 'invert(0)' : 'invert(1)',
            },
        },
        detail: {
            width: '100%',
            marginRight: '0px',
        },
        name: {
            width: '100%',
            fontSize: '24px',
            lineHeight: '28px',
            margin: 0,
            padding: 0,
            position: 'relative',
            display: 'inline-block',
            fontWeight: 600,
            [theme.breakpoints.down('sm')]: {
                fontSize: '18px',
                lineHeight: '22px',
            },
        },
        region: {
            fontSize: '18px',
            lineHeight: '28px',
            marginBottom: theme.spacing(2),
            [theme.breakpoints.down('sm')]: {
                fontSize: '16px',
            },
        },
        verified: {
            display: 'flex',
            width: 'fit-content',
            backgroundColor: '#30ab4a',
            color: 'white',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 4,
            '& p': {
                fontSize: 13,
            },
        },
        verifiedIcon: {
            backgroundColor: '#38b653',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '3px 4px',
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4,
            [theme.breakpoints.down('sm')]: {
                '& span': {
                    fontSize: 14,
                },
            },
        },
    };
});
